<!--单位信息模块-->
<template>
  <div class="unitInfoBody topLeftTitleContent2">
    <div class="titled"> <img class="img" src="@/assets/kanban/11.png" />功率监控
      <span class="iconed" @click="getList();detail_status = true" style="cursor: pointer;margin-left: auto;">
        <img src="@/assets/kanban/Frame10.png" style="margin-right: 10px;" />
        <img src="@/assets/kanban/Union.png" />
      </span>
    </div>
    <div class="unitContent bodyBorder">
      <vchart ref='vchartPie2' style="width:100%;height:100%;"></vchart>
    </div>

    <!-- 功率曲线 -->
    <el-dialog title="功率监控" v-dialogDrag :visible.sync="detail_status" center :modal="false">
      <div style="display: block;width: 100%;">
        <el-checkbox-group v-model="checkList">
          <el-checkbox v-for="(e,i) in checkListed" :key="i" :label="e" />
        </el-checkbox-group>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="detail_status = false" type="info">取 消</el-button>
          <el-button type="primary" :loading="loading" @click="flag = true;getListed();aaa()">确 定
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
  import columnsContent from '@/page/unitKanBan/component/columnsContent.vue'
  import {parseTime} from "@/utils";
  import request from "@/api/http.js";
  import vchart from '@/components/module/chart/vchart.vue';
  let proportion2;
  export default {
    components: {
      columnsContent,
      vchart
    },

    data () {
      return {
        loading: false,
        detail_status: false,
        checkList: [],
        checkListed: [],
        timeOut: '',
        nowSeries: [],
        refreshInterval: 2000,
        variableName: '',
        options: {
          tooltip: {
            trigger: 'axis',
            confine: true,
            axisPointer: {
              animation: false
            }
          },
          xAxis: {
            show: false,
            type: 'category',
            data: [],
            axisLabel: {
              textStyle: {
                color: '#ffffff',
              },
            },
            splitLine: {
              lineStyle: {
                type: 'dashed',
                color: '#6f7284'
              }
            },
          },
          yAxis: {
            type: 'value',
            axisLabel: {
              textStyle: {
                color: '#ffffff',
              },
            },
            max: 'dataMax',
            splitLine: {
              lineStyle: {
                type: 'dashed',
                color: '#6f7284'
              }
            },
            boundaryGap: [0,'100%'],
          },
          grid: {
            left: '50',
            right: '5%',
            bottom: '20'
          },
          // legend: {
          //   icon: "circle", //
          //   type: 'scroll',
          //   bottom: '20px',
          //   top: 30,
          //   tooltip: {
          //     show: true
          //   },
          //   textStyle: {
          //     color: '#fff'
          //   }
          // },
          series: []
        },
        flag: true,
        kanbanCountInfo: {
          device: 0,
          monitoringPoint: 0,
          user: 0,
        }
      }
    },

    mounted () {
      this.init()
      this.getList()
      //初始化图表


      this.timeOut=setInterval(() => {
        if(this.variableName) {
          this.getListed()
        }
      },5000);

    },
    destroyed () {
      if(this.timeOut) {
        clearInterval(this.timeOut)
      }
    },
    computed: {
      nowUnit () {
        return this.$store.unitStore.getters.getNowUnit
      },
      showExport () {
        //看看是不是应该显示导出运维报告
        return this.$router.currentRoute.path!='/temperatureOverView'
      },
      getBackgroudImageStyle () {
        return this.$store.resourcesStore.getters.getBackgroudImageStyle
      },
      getResourcesByName () {
        return this.$store.resourcesStore.getters.getResourcesByName
      },
    },
    watch: {
      nowUnit (nv,ov) {
        this.initData()
      }
    },
    methods: {
      aaa () {
        console.log(this.checkList,'this.checkList');
        var d=[];
        this.checkList.map(v => {
          d.push(v)
        })
        var a=d.length? d.join(','):'';
        var data=new FormData();
        data.append("variableNames",a);
        data.append("appType",'31');
        this.loading=true;
        request({url: "/loadPower/saveCheckLowerPower",method: "post",data}).then(res => {
          this.loading=false;
          this.detail_status=false;
        })
      },
      getList () {
        var res={
          "code": 200,
          "message": "操作成功",
          "data": {
            "C栋B区一层配电房": [
              "C栋B区1楼P14-4141-电容柜.A相电流",
              "C栋B区1楼P08-4081-进线柜.A相电流"
            ],
            "C栋B区二层配电房": [
              "C栋B区2楼P01-4011-进线柜.A相电流"
            ],
            "C栋B区三层配电房": [
              "C栋B区3楼P01-4011-进线柜.A相电流"
            ],
            "C栋B区四层配电房": [
              "C栋B区4楼P01-4011-进线柜.A相电流"
            ],
            "C栋B区五层配电房": [
              "C栋B区5楼P01-4011-进线柜.A相电流"
            ],
            "C栋B区六层配电房": [
              "C栋B区6楼P01-4011-进线柜.A相电流"
            ],
            "C栋A区一层配电房": [
              "C栋A区一楼P01-4011-进线柜.A相电流",
              "C栋A区一楼P09-4091-进线柜.A相电流"
            ],
            "C栋A区二层配电房": [],
            "C栋A区三层配电房": [],
            "C栋A区四层配电房": [
              "C栋A区4楼P05-4051-进线柜.A相电流",
              "C栋A区4楼P06-4061-进线柜.A相电流"
            ],
            "C栋A区五层配电房": [
              "C栋A区5楼P07-4071-出线柜.A相电流",
              "C5FA-4011-进线柜.A相电流"
            ],
            "C栋A区六层配电房": [
              "C栋A区6楼P01-4011-进线柜.A相电流"
            ],
            "D栋一层配电房": [
              "D栋配电房P10-4101-进线柜.A相电流"
            ],
            "E栋一层配电房": [
              "E栋配电房P01-4011-进线柜.A相电流"
            ],
            "A栋一层配电房": [
              "A栋1楼P01-4011-进线柜.A相电流",
              "A栋1楼P20-4201-进线柜.A相电流"
            ],
            "A栋二层配电房": [
              "A2F-4011-进线柜.A相电流",
              "A2F-4121-进线柜.A相电流"
            ],
            "A栋三层配电房": [
              "A3F-4011-进线柜.A相电流",
              "A3F-4131-进线柜.A相电流"
            ],
            "A栋四层配电房": [
              "A4F-4011-进线柜.A相电流",
              "A4F-4131进线柜.A相电流"
            ],
            "A栋五层配电房": [
              "A5F-4141-进线柜.A相电流",
              "A5F-4011-进线柜.A相电流"
            ],
            "A栋六层配电房": [
              "A6F-4011-进线柜.A相电流"
            ],
            "B栋一层配电房": [
              "B栋1楼P21-4211G-进线柜.A相电流",
              "B栋1楼P01-4011-进线柜.A相电流"
            ],
            "B栋二层配电房": [
              "B2F-4011-进线柜.A相电流",
              "B2F-4131-进线柜.A相电流"
            ],
            "B栋三层配电房": [
              "B3F-4131-进线柜.A相电流",
              "B3F-4011-进线柜.A相电流"
            ],
            "B栋四层配电房": [
              "B4F-4011-进线柜.A相电流",
              "B4F-4121-进线柜.A相电流"
            ],
            "自助设备": [],
            "B栋六层配电房": [
              "B6F-4011-进线柜.A相电流"
            ],
            "仓库配电房": [
              "仓库配电房-4011-进线柜.A相电流"
            ],
            "食堂配电房 ": [
              "食堂配电房-4011-进线柜.A相电流"
            ],
            "高压保护计量表": [
              "C1FB-G06-高压计量表.A相电流",
              "A1F-G08-高压计量表.A相电流",
              "E1F-P01-高压计量表.A相电流",
              "C6FB-G04-高压计量表.A相电流",
              "E1F-P03-高压计量表.A相电流",
              "C3FB-G06-高压计量表.A相电流",
              "B1F-G01-高压计量表.A相电流",
              "B6F-G08-高压计量表.A相电流",
              "A1F-G01-高压计量表.A相电流",
              "C4FB-G06-高压计量表.A相电流",
              "B1F-G08-高压计量表.A相电流"
            ],
            "区域类型": [],
            "C栋B区一楼车间": [],
            "被勾选的设备": [
              "C栋B区一层配电房",
              "C栋B区六层配电房",
              "C栋B区三层配电房",
              "C栋B区四层配电房",
              "E栋一层配电房",
              "A栋二层配电房",
              "A栋三层配电房",
              "食堂配电房",
              "C栋B区一楼车间"
            ]
          }
        };

        if(res.code==200) {
          var d=res.data['被勾选的设备'];
          this.variableName={};
          this.checkListed=[];
          this.checkList=d||[];
          for(const key in res.data) {
            if(key=='被勾选的设备') {

            } else {
              this.variableName[key]=res.data[key]
              this.checkListed.push(key);
            }
          }
          this.getListed()
        }
      },
      getListed () {
        var res={
          "code": 200,
          "message": "操作成功",
          "data": {
            "C1FB-4141-进线柜.总有功功率": "948.4",
            "C1FB-4081-2000KVA总表.瞬时总有功功率": "814.08",
            "C6FB-4011-2500KVA总表.瞬时总有功功率": "23.9",
            "C3FB-4011-2500KVA总表.总有功功率": "344.8",
            "C4FB-4011-2500KVA总表.瞬时总有功功率": "1044.9",
            "E1F-4011-2500KVA总表.瞬时总有功功率": "1006.3",
            "A栋1楼P01-4011-进线柜.瞬时总有功功率": "0",
            "A1F-P20-4201-进线柜.瞬时总有功功率": "439.5",
            "B1F-P21-4211G-进线柜.瞬时总有功功率": "0",
            "B1F-P01-4011-进线柜.瞬时总有功功率": "860.3"
          }
        };

        this.nowSeries=[{
          data: [],
          barWidth: '70%',
          label: {
            show: true,
            position: 'top',
            textStyle: {
              fontSize: '16',
              fontWeight: 'bold'
            },
          },
          itemStyle: {
            normal: {
              color: function(params) {
                var colors=['#c23531','#2f4554','#d48265','#91c7ae','#749f83','#ca8622','#bda29a','#6e7074','#546570','#ffff66']; // 自定义颜色列表
                return colors[params.dataIndex]; // 返回对应索引位置的颜色
              }
            }
          },
          type: "bar",
        }];
        var d=[]
        for(const key in res.data) {
          d.push(key)
          this.nowSeries[0].data.push(res.data[key])

        }

        this.options.xAxis.data=d;
        this.options.series=this.nowSeries;
        this.$refs.vchartPie2.setData(this.options);

      },
      // 初始化
      init () {
        // proportion2=echarts.init(document.getElementById("proportion2"));
        // proportion2.setOption(this.options,true);
        this.$refs.vchartPie2.setData(this.options);
      },
      exportReport () {
        this.$router.push('maintenanceReport')
        return
        this.$dialogMethod.showLoading("正在生成报告。。。")
        this.$api.reportApi.exportUnitMonthReportWord(this.nowUnit.id,new Date(new Date().formatByMonth()).getTime()-24*
          60*
          60*1000,respon => {
            if(!respon.includes('%2F')) {
              this.$dialogMethod.showMessage(respon)
              return
            }
            saveAs(DWSystemSetting.downloadUrl+'/'+respon,respon.substring(respon.lastIndexOf('%2F')+3))
            this.$dialogMethod.closeLoading()
          })
      },
      initData () {
        this.$api.unitApi.getKanbanCountInfo(this.nowUnit.id,respon => {
          this.kanbanCountInfo=respon
        })
      }
    }
  }
</script>
<style>
  .topLeftTitleContent2 .el-checkbox__label {
    color: #000;
  }

  .topLeftTitleContent2 .el-dialog__title {
    color: #000;
  }
</style>
<style scoped>
  .bodyBorder {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: none;
    width: 100%;
  }

  .dialoged {
    background: url("../../../assets/kanban/Group132.png") no-repeat;
    width: 307px;
    height: 177px;
    position: absolute;
    top: -136px;
    right: 109px;
  }

  .dialoged .dialoged_box .dialoged_tit {
    font-weight: bold;
  }

  .dialoged .dialoged_box .p {
    color: #DF9B36;
    font-family: Microsoft YaHei;
    font-weight: regular;
    font-size: 12px;
    padding-left: 8px;

  }

  .dialoged .dialoged_box {
    font-family: Microsoft YaHei;
    font-size: 12px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    height: 100%;
    box-sizing: border-box;
    padding: 6px 0 13px 12px;
  }

  .smallWindow {
    width: calc(50% - 6px);
    height: 270px;
  }

  .topLeftTitleContent2 {
    position: relative;
    border: 4px solid #19485C;
    box-sizing: border-box;
  }

  .topLeftTitleContent2 .titled .img {
    padding: 6px 4px;
    padding-top: 4px;
  }

  .topLeftTitleContent2 .titled {
    /* background-image: linear-gradient(to top, #31A9DD, #AAE5FF); */
    color: #fff;
    -webkit-background-clip: text;
    font-family: Microsoft YaHei;
    font-weight: bold;
    font-size: 16px;
    display: flex;
    align-items: center;
    border-bottom: 2px solid;
    border-image: linear-gradient(-90deg, #31A9DD00 0%, #32AADD 100%) 1;

  }

  @import url("../../../components/css/usePowerUnit.css");

  .unitInfoBody {
    height: 274px;
  }

  .columnsContent {
    margin: 20px 10px;
  }

  .unitContent {
    height: calc(100% - 31px);
    overflow: hidden;
  }

  .userInfo {
    width: 45%;
    height: 60%;
    display: flex;
    align-items: center;
    justify-content: space-around;
  }

  .userInfo div {
    display: flex;
    align-items: center;
    flex-direction: column;
    height: 70%;
    justify-content: space-around;
  }

  .userInfo div p {
    width: 100%;
    height: 5px;
  }

  .userInfo div span {
    font-size: .3rem;
  }

  .userInfo div:nth-child(1) span {
    color: #86e4f5;
  }

  .userInfo div:nth-child(1) p {
    background-color: #86e4f5;
  }

  .userInfo div:nth-child(2) span {
    color: #ff9900;
  }

  .userInfo div:nth-child(2) p {
    background-color: #ff9900;
  }

  .userInfo div:nth-child(3) span {
    color: #0293fc;
  }

  .userInfo div:nth-child(3) p {
    background-color: #0293fc;
  }
</style>